type AWSAuthProviderProps = {
  children: React.ReactNode;
};

function AWSAuthProvider(props: AWSAuthProviderProps) {
  const {children} = props;

  return <>{children}</>;
}

export default AWSAuthProvider;
